import React from "react";

function PoliceMapBox() {

    let height = window.innerHeight;
    console.log(height)
    let heightvh = height*0.615 + "vh"
    console.log(heightvh)

    return (
            <div>
                <iframe src="policemap.html" width="100%" height={heightvh} style={{overflow: "none"}}/>
            </div>
    );

}

export default PoliceMapBox;

// API -> AIzaSyCCMQlB41vn2nIVOAHuTnt6nrk8QxpEf5o
